'use client'
import { socket } from '../Containers/MainContainer';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';

function VerifyAdmin({ rank }) {
    const [pcSent, sPCS] = useState(false);
    const [code, setCode] = useState(0)

    return (rank <= 1 ? <span className="loader"></span> : <>

        <div style={{
            minHeight: '100vh',
            background: '#0d1117',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px'
        }}>

            <div style={{
                background: '#161b22',
                border: '1px solid #21262d',
                borderRadius: '12px',
                padding: '32px',
                maxWidth: '420px',
                width: '100%'
            }}>
                <div>
                    <h3 style={{
                        fontSize: '20px',
                        fontWeight: '700',
                        color: '#e6edf3',
                        marginBottom: '8px'
                    }}>Security Check</h3>
                    <p style={{
                        color: '#8b949e',
                        fontSize: '14px',
                        lineHeight: '1.5',
                        marginBottom: '16px'
                    }}>This IP is not in your trusted list. Please request a passcode and then verify it.</p>
                    {pcSent === false ? <p onClick={() => {
                        sPCS(true)
                        if (window.socket != undefined) {
                            socket.emit('adminAction', {
                                action: 'send_admin_verification_email'
                            })
                        }
                    }} style={{
                        color: '#58a6ff',
                        cursor: 'pointer',
                        fontSize: '14px',
                        marginTop: '8px'
                    }}>
                        Send passcode to email
                    </p>
                        : <><div style={{ marginTop: '12px' }}>
                            <p style={{
                                color: '#3fb950',
                                fontSize: '14px',
                                padding: '10px 12px',
                                background: 'rgba(63,185,80,0.15)',
                                borderRadius: '8px',
                                marginBottom: '12px'
                            }}>Passcode sent to your email. Please check your spam folder too</p>
                            <p onClick={() => {
                                socket.emit('adminAction', {
                                    action: 'send_admin_verification_email'
                                })
                            }} style={{
                                color: '#58a6ff',
                                cursor: 'pointer',
                                fontSize: '14px',
                                marginTop: '8px',
                                marginBottom: '16px'
                            }}>
                                Resend passcode
                            </p>
                            <div style={{ marginTop: '10px' }}>
                                <label style={{
                                    display: 'block',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#8b949e',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.8px',
                                    marginBottom: '6px'
                                }}>Passcode</label>
                                <input
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setCode(e.target.value)
                                    }}
                                    type="password"
                                    style={{
                                        width: '100%',
                                        padding: '10px 14px',
                                        background: '#0d1117',
                                        border: '1px solid #30363d',
                                        borderRadius: '8px',
                                        color: '#e6edf3',
                                        fontSize: '14px',
                                        outline: 'none',
                                        boxSizing: 'border-box'
                                    }}
                                    placeholder="Enter passcode"
                                    onFocus={(e) => { e.target.style.borderColor = '#58a6ff' }}
                                    onBlur={(e) => { e.target.style.borderColor = '#30363d' }}
                                />
                            </div>
                        </div>
                            <div style={{ marginTop: '16px' }}>
                                <button onClick={(e) => {
                                    e.preventDefault();
                                    socket.emit('adminAction', {
                                        action: 'check_admin_verification_code',
                                        code,
                                    })
                                }} type="submit" style={{
                                    width: '100%',
                                    padding: '10px 16px',
                                    background: '#238636',
                                    border: '1px solid #2ea043',
                                    borderRadius: '8px',
                                    color: '#ffffff',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'background 0.2s'
                                }}
                                    onMouseOver={(e) => { e.target.style.background = '#2ea043' }}
                                    onMouseOut={(e) => { e.target.style.background = '#238636' }}
                                >
                                    Submit
                                </button>
                            </div> </>}

                </div>
            </div>
        </div>
    </>)
}

export default VerifyAdmin
